<template>
  <div class="image-label">
    <!-- 工具栏 -->
    <el-radio-group
      v-model="drawMode"
      size="large"
      fill="#409eff"
      @change="onSetMode"
      style="margin:8px 0"
    >
      <el-radio-button label="PAN">
        <el-tooltip content="鼠标" placement="top">
          <i class="el-icon-mouse"></i>
        </el-tooltip>
      </el-radio-button>
      <el-radio-button label="POLYGON" v-if="labelValue">
        <el-tooltip content="框选目标" placement="top">
          <i class="el-icon-edit"></i>
        </el-tooltip>
      </el-radio-button>
    </el-radio-group>
    <!-- 标注容器 -->
    <div
      id="AILabel-container"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-background="rgba(0,0,0,.1)"
    >
      <el-popover
        v-model="popoverVisible"
        :virtual-ref="$refs.popoverRef"
        virtual-triggering
        trigger="manual"
        placement="right-start"
        width="140"
        :show-arrow="false"
      >
        <div class="menu-item danger" @click="deleteLabel">
          删除
        </div>
        <div
          ref="popoverRef"
          class="popover-anchor"
          slot="reference"
          :style="{ left: menuX + 'px', top: menuY + 'px' }"
        ></div>
      </el-popover>

      <!-- 右键菜单 -->
    </div>
  </div>
</template>
<script>
import AILabel from "ailabel";
import { Message } from "element-ui";

export default {
  name: "AILabelRect",

  props: {
    value: {
      required: true
    },
    fileUrl: {
      type: String,
      required: true
    },
    labelValue: {
      type: Object,
      required: false
    },
    labelOptions: {
      required: false
    }
  },

  data() {
    return {
      drawMode: "PAN",
      loading: false,

      ailabel: null,
      imageLayer: null,
      featureLayer: null,
      textLayer: null,

      imageW: 0,
      imageH: 0,
      imageBlob: "",

      labelList: [],
      polygonStartPoint: null,
      // 右键菜单
      popoverVisible: false,
      menuX: 0,
      menuY: 0,
      clickRegion: null
    };
  },
  watch: {
    fileUrl: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadImage();
        }
      }
    },
    labelOptions: {
      immediate: true,
      deep: true,
      handler(val) {
        console.log();
        const ids = val.map(i => i.label);
        console.log(ids);
        this.labelList.forEach(item => {
          console.log(item.props.label);
          if (!ids.includes(item.props.label)) {
            this.featureLayer.removeFeatureById(item.id);
            this.textLayer.removeTextById(item.id);
          }
        });
        this.labelList = this.labelList.filter(i =>
          ids.includes(i.props.label)
        );
        this.$emit("input", this.labelList);
      }
    }
  },
  mounted() {
    // this.loadImage();
  },

  methods: {
    /** 加载图片 */
    async loadImage() {
      const res = await fetch(this.fileUrl);
      const blob = await res.blob();
      this.imageBlob = URL.createObjectURL(blob);

      const img = new Image();
      img.onload = () => {
        this.imageW = img.width;
        this.imageH = img.height;
        this.initAILabel();
      };
      img.src = this.imageBlob;
    },

    /** 初始化 AILabel */
    initAILabel() {
      const container = document.getElementById("AILabel-container");
      const cw = container.clientWidth;
      const ch = container.clientHeight;

      const ratio = Math.min(cw / this.imageW, ch / this.imageH);
      const zoom = (cw / ratio) * 0.9;

      this.ailabel = new AILabel.Map("AILabel-container", {
        center: { x: this.imageW / 2, y: this.imageH / 2 },
        zoom,
        withHotKeys: true
      });

      this.ailabel.setDrawingStyle({
        strokeStyle: "#409EFF",
        fillStyle: "#409EFF",
        lineWidth: 4
      });

      this.renderImageLayer();
      this.renderFeatureLayer();
      this.renderTextLayer();
      this.bindEvents();
    },

    renderImageLayer() {
      const layer = new AILabel.Layer.Image(
        "img-layer",
        {
          src: this.imageBlob,
          width: this.imageW,
          height: this.imageH
        },
        {},
        { zIndex: 5 }
      );

      layer.events.on("loadStart", () => (this.loading = true));
      layer.events.on("loadEnd", () => (this.loading = false));

      this.ailabel.addLayer(layer);
      this.imageLayer = layer;
    },

    renderFeatureLayer() {
      const layer = new AILabel.Layer.Feature(
        "feature-layer",
        {},
        { zIndex: 10 }
      );
      this.ailabel.addLayer(layer);
      this.featureLayer = layer;
    },

    renderTextLayer() {
      const layer = new AILabel.Layer.Text("text-layer", {}, { zIndex: 12 });
      this.ailabel.addLayer(layer);
      this.textLayer = layer;
    },
    // 判断点是否在标注图形内

    isPointInPolygon(point, polygon) {
      let inside = false;
      for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;

        // 判断射线是否与边相交
        const intersect =
          yi > point.y !== yj > point.y &&
          point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi;

        if (intersect) inside = !inside;
      }

      return inside;
    },
    isPointInFeature(point) {
      if (!point) return false;

      // 遍历所有图形
      for (const feature of this.labelList.reverse()) {
        const shape = feature.shape;

        let isIn = false;
        isIn = this.isPointInPolygon(point, shape);

        if (isIn) {
          return feature;
        }
      }

      return false;
    },
    bindEvents() {
      /** 绘制完成 */
      this.ailabel.events.on("drawDone", (type, data) => {
        let errorFlag = false;
        data.forEach(item => {
          if (
            item.x < 0 ||
            item.y < 0 ||
            item.x > this.imageW ||
            item.y > this.imageH
          ) {
            errorFlag = true;
            return;
          }
        });
        if (errorFlag) {
          Message.warning("标注区域超出图片范围，请重新标注");
          requestAnimationFrame(() => {
            this.onSetMode("PAN");
          });
          return;
        }
        this.drawMark(data, this.labelValue);
        requestAnimationFrame(() => {
          this.onSetMode("PAN");
        });
      });
      this.ailabel.events.on("drawUpdate", (type, data) => {
        // if (type !== "POLYGON") return;
        console.log(data);
        this.polygonStartPoint = data.point; // 起点
      });
      /** 点击 */
      this.ailabel.events.on("click", e => {
        if (this.drawMode !== "PAN") {
          return;
        }

        const resData = this.isPointInFeature(e.global);
        this.popoverVisible = false;
        if (resData) {
          this.menuX = e.screen.x;
          this.menuY = e.screen.y;
          this.clickRegion = resData;
          requestAnimationFrame(() => {
            this.popoverVisible = true;
          });
        }
      });
    },
    getPolygonCentroid(pts) {
      // 去掉最后重复点

      let area = 0;
      let cx = 0;
      let cy = 0;

      for (let i = 0; i < pts.length; i++) {
        const j = (i + 1) % pts.length;
        const p1 = pts[i];
        const p2 = pts[j];

        const cross = p1.x * p2.y - p2.x * p1.y;
        area += cross;
        cx += (p1.x + p2.x) * cross;
        cy += (p1.y + p2.y) * cross;
      }

      area *= 0.5;

      return {
        x: cx / (6 * area),
        y: cy / (6 * area)
      };
    },
    /** 设置模式 */
    onSetMode(mode) {
      this.drawMode = mode;
      this.ailabel.setMode(mode);
    },
    setOptions(data, label) {
      drawMark(data, label);
      this.$emit("input", this.labelList);
    },
    /** 创建标注 */
    drawMark(data, label) {
      const id = `${Date.now()}-${this.labelList.length}`;
      console.log("drawmark", data);
      const polygon = new AILabel.Feature.Polygon(id, { points: data }, label, {
        strokeStyle: label.color,
        fillStyle: label.color,
        globalAlpha: 0.2,
        stroke: true,
        fill: true
      });

      this.featureLayer.addFeature(polygon);
      const center = this.getPolygonCentroid(data);
      console.log(data, center);
      const text = new AILabel.Text(
        id,
        {
          text: label.label,
          position: center,
          offset: { x: -label.label.length * 10, y: -26 }
        },
        label,
        {
          fillStyle: label.color,
          background: true,
          fontColor: "#ffffff",
          lineWidth: 0,
          strokeStyle: "transparent",
          font: "normal 20px Arial"
        }
      );

      this.textLayer.addText(text);

      this.labelList.push({
        id,
        shape: data,
        props: label
      });
      this.$emit("input", this.labelList);
    },

    /** 命中检测 */
    getFeatureByPoint(point) {
      return this.labelList.find(f => {
        const { x, y, width, height } = f.shape;
        return (
          point.x >= x &&
          point.x <= x + width &&
          point.y >= y &&
          point.y <= y + height
        );
      });
    },

    /** 删除 */
    deleteLabel() {
      const id = this.clickRegion.id;
      this.featureLayer.removeFeatureById(id);
      this.textLayer.removeTextById(id);
      this.labelList = this.labelList.filter(i => i.id !== id);
      this.popoverVisible = false;
      this.$emit("input", this.labelList);
      Message.success("删除成功");
    }
  }
};
</script>
<style scoped>
.image-label {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #409eff;
}
#AILabel-container {
  flex: 1;
  border-top: 1px solid #409eff;
  position: relative;
  overflow: hidden;
  height: 100%;
}

.popover-anchor {
  position: absolute;
  width: 0;
  height: 0;
}

.menu-item {
  cursor: pointer;
  padding: 6px 10px;
}
.menu-item:hover {
  background: #f3f4f6;
}
.menu-item.danger {
  color: #ef4444;
}

.label-list {
  padding: 16px;
}
.label-item {
  padding: 8px;
  margin-bottom: 8px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.label-item.is-active {
  outline: 2px solid #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageSplit.vue